import SetDiscountModal from "../../components/cruise/setDiscountModal"
import DetailDescount from "./detailDescount";

export default function GeneralRateCell(props) {
  return (
    <>
      {(props.user.role === "admin") ? (
        <>
          <SetDiscountModal stateSpace={props.space} />
          <DetailDescount stateSpace={props.space} />
        </>
      ) : (
        <>
          <p className="mb-[-2px]">- {props.space.special_discount_price || '0.00'}</p>
          <DetailDescount stateSpace={props.space} />
        </>
      )}
    </>
  )
}